import { Injectable, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})

export class NoticeComponent {
  // public structureMessage = new StructureMessage();
  constructor(
    public snackBar: MatSnackBar
  ) { }

  showMessageError(data: any) {
    structureMessage.setData(data, 'Falhou');
    this.snackBar.openFromComponent(RbNoticeBarComponent, {
      duration: 5000,
      verticalPosition: 'bottom',
      horizontalPosition: 'start',
      panelClass: 'rb-alert-message-error',
    });
  }

  showMessageWarning(data: any) {
    structureMessage.setData(data, 'Atenção');
    this.snackBar.openFromComponent(RbNoticeBarComponent, {
      duration: 0,
      verticalPosition: 'bottom',
      horizontalPosition: 'start',
      panelClass: 'rb-alert-message-warning'
    });
  }

  showMessageSuccess(data: any) {
    structureMessage.setData(data, 'Sucesso');
    this.snackBar.openFromComponent(RbNoticeBarComponent, {
      duration: 5000,
      verticalPosition: 'bottom',
      horizontalPosition: 'start',
      panelClass: 'rb-alert-message-success'
    });
  }

  showMessageInfo(data: any) {
    structureMessage.setData(data, 'Atenção');
    this.snackBar.openFromComponent(RbNoticeBarComponent, {
      duration: 5000,
      verticalPosition: 'bottom',
      horizontalPosition: 'start',
      panelClass: 'rb-alert-message-info'
    });
  }
}

@Component({
  selector: 'app-rb-notice-bar',
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss']
})

export class RbNoticeBarComponent  implements OnInit {

  public arrayNotice: object[] = [];
  public dataNotice: any;
  public titleNotice: any;

  constructor(
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.formatMessage(structureMessage.getData());
    this.titleNotice = structureMessage.getTitle();
  }

  getTypeOf(data) {
    return typeof data;
  }

  formatMessage(data: any) {
    if (data && typeof data === 'object') {
      for (let key in data) {
        if (key != 'success' && key != 'executed') {
          this.arrayNotice.push(data[key]);
        }
      }
      if (this.arrayNotice.length < 1 && data.length > 0)  {
        this.arrayNotice = data;
      }
    } else {
      this.dataNotice = data;
    }
  }

  close() {
    this.snackBar.dismiss();
  }


}

export class StructureMessage {
  public data: any;
  public title: any;

  setData(data, title) {
    this.data = data;
    this.title = title;
  }

  getData() {
    return this.data;
  }
  getTitle() {
    return this.title;
  }
}

const structureMessage = new StructureMessage();
